module.exports = __webpack_public_path__ + "img/hear-no-evil-monkey.0bedfa2e.png";